<template>
  <div class="featured-dorms__list dorm-card__list user__list-wrp">
    <container>
      <div class="result-bracket__title user__list-count">
        You Have <span class="result-bracket__count"> {{ movies.length }} </span> Movies in Your Watchlist!
      </div>
      <row>
        <div
          v-for="movie in movies"
          :key="movie.id"
          class="featured-dorms__col col-xl-4 col-lg-4 col-md-4 user__list">
          <movie-card
            :movie="movie"
          />
        </div>
      </row>
    </container>
  </div>
</template>

<script>
import MovieCard from '@/components/MovieCard'
import axios from 'axios'
export default {
  name: 'UserWatchlist',
  components: {
    MovieCard
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Watchlist Movies',
      link: [
        { rel: 'canonical' },
        { href: window.location.origin + '/user-management/favorites' }
      ] 
    }
  },    
  data () {
    return {
      movies: [],
      errors: []
    }
  },
  methods: {
    getWatchlist() {
      let self = this
      const session_id = window.localStorage.getItem('session_id')
      axios.get(`/3/account/{account_id}/watchlist/movies?api_key=a11ac97c6bdb99adc0845654be0902a8&session_id=${session_id}&language=en-US&sort_by=created_at.asc&page=1`)
        .then(response => {
          self.movies = response.data.results
        })
        .catch(e => {
          self.errors.push(e)
        })
    },    
  },
  mounted () {
    this.getWatchlist()
  },  
}
</script>

<style lang="scss">

</style>
